import { createRouter, createWebHistory } from "vue-router";
import TreinosView from "@/views/TreinosView.vue";
import NewTreinoView from "@/views/NewTreinoView.vue";
import ExerciciosView from "@/views/ExerciciosView.vue";
import FormacoesViews from "@/views/FormacoesView.vue";
import LoginComponent from "@/components/auth/LoginComponent.vue";
import NewExercicioView from "@/views/NewExercicioView.vue";

import BoardView from "@/views/BoardView.vue";
import SelectBoard from "../views/SelectBoard.vue";

import HomeView from "@/views/HomeView.vue";
import ProfileView from "@/views/ProfileView.vue";
import PaymentView from "@/views/PaymentView.vue";
import VideosView from "@/views/VideosView.vue";
import UsersViews from "@/views/admin/UserView.vue";
import MailView from "@/views/admin/MailView.vue";
import PlansView from "@/views/admin/PlansView.vue";
import TeamsView from "@/views/admin/TeamsView.vue";
import TrashView from "@/views/admin/TrashView.vue";
import NewTeamView from "@/views/admin/NewTeamView.vue";
import TeamView from "@/views/team/TeamView.vue";
import UsersView from "@/views/team/UsersView.vue";
import CategoriesView from "@/views/team/CategoriesView.vue";
import TeamTreinosView from "@/views/team/TreinosView.vue";
import MyTeamsView from "@/views/TeamsView.vue";

import WeeksView from "@/views/week/WeeksView.vue";
import WeekView from "@/views/week/WeekView.vue";
import NewWeekView from "@/views/week/NewWeekView.vue";

import NotFoundView from "@/views/NotFoundView.vue";
import HelpComponent from "@/components/HelpComponent.vue";
import CampsView from "@/views/CampsView.vue";
import NotifyView from "@/views/admin/NotifyView.vue";

import NewFitnesView from "../views/fitnes/NewFitnesView.vue";
import FitnesView from "../views/fitnes/FitnesView.vue";
import ExercicesView from "../views/fitnes/ExercicesView.vue";
import NewFitnesExView from "../views/fitnes/NewFitnesExView.vue";
import FitnesExView from "../views/fitnes/FitnesExView.vue";

import VideoSessionsView from "../views/video/VideoSessionsView.vue";
import NewVideoSessionView from "../views/video/NewVideoSessionView.vue";
import VideoExercicesView from "../views/video/VideoExercicesView.vue";
import NewVideoExView from "../views/video/NewVideoExView.vue";
import VideoExView from "../views/video/VideoExView.vue";

import FilesView from "../views/admin/FilesView.vue";
import GifsView from "../views/admin/GifsView.vue";

import AiRechargeView from "../views/AiRecharge.vue";
import TermsView from "@/views/TermsView.vue";
import PolicyView from "@/views/PolicyView.vue";

const routes = [
    {
        path: "/",
        name: "Home",
        component: HomeView,
    },
    {
        path: "/profile",
        name: "Profile",
        component: ProfileView,
    },
    {
        path: "/payment",
        name: "Plans",
        component: PaymentView,
    },
    {
        path: "/recharge",
        name: "Recarga",
        component: AiRechargeView,
    },
    {
        path: "/treinos",
        name: "Treinos",
        component: TreinosView,
    },
    {
        path: "/new-treino",
        name: "Novo Treino",
        component: NewTreinoView,
    },
    {
        path: "/formacoes",
        name: "Formacoes Taticas",
        component: FormacoesViews,
    },
    {
        path: "/videos",
        name: "Videos",
        component: VideosView,
    },
    {
        path: "/treino/:id",
        name: "Exercicios",
        component: ExerciciosView,
    },
    {
        path: "/marcar/:id",
        name: "Marcar",
        component: NewExercicioView,
    },
    {
        path: "/marcar",
        name: "MarcarFormacao",
        component: NewExercicioView,
    },
    {
        path: "/edit/:id",
        name: "EditExercice",
        component: NewExercicioView,
    },
    {
        path: "/board",
        name: "Board",
        component: BoardView,
    },
    {
        path: "/select-board",
        name: "SelectBoard",
        component: SelectBoard,
    },
    {
        path: "/clubes",
        name: "MeusClubes",
        component: MyTeamsView,
    },
    {
        path: "/select",
        name: "SelectCamp",
        component: CampsView,
    },
    // teams view
    {
        path: "/team/profile",
        name: "MyTeam",
        component: TeamView,
    },
    {
        path: "/team/users",
        name: "Users Team",
        component: UsersView,
    },
    {
        path: "/team/categories",
        name: "Categories Team",
        component: CategoriesView,
    },
    {
        path: "/team/treinos",
        name: "Treinos Team",
        component: TeamTreinosView,
    },

    // programacao semanal
    {
        path: "/weeks",
        name: "Weeks View",
        component: WeeksView,
    },
    {
        path: "/week",
        name: "New Weeks",
        component: NewWeekView,
    },
    {
        path: "/week/:id",
        name: "Week",
        component: WeekView,
    },

    // treinamento fitnes
    {
        path: "/new-fitnes",
        name: "newFitnes",
        component: NewFitnesView,
    },
    {
        path: "/fitnes",
        name: "Fitnes",
        component: FitnesView,
    },
    {
        path: "/fitnes/:id",
        name: "FitnesView",
        component: ExercicesView,
    },
    {
        path: "/fitnes_ex/:id",
        name: "NewFitnesEx",
        component: NewFitnesExView,
    },
    {
        path: "/fitnes_ex/:id/view",
        name: "FitnesEx",
        component: FitnesExView,
    },

    // Sessao de treino com video
    {
        path: "/new-video-session",
        name: "newVideoSession",
        component: NewVideoSessionView,
    },
    {
        path: "/video-sessions",
        name: "VideoSessions",
        component: VideoSessionsView,
    },
    {
        path: "/video-sessions/:id",
        name: "VideoSession",
        component: VideoExercicesView,
    },
    {
        path: "/video-sessions-ex/:id",
        name: "NewVideoSessionEx",
        component: NewVideoExView,
    },
    {
        path: "/video-sessions-ex/:id/view",
        name: "VideoSessionEx",
        component: VideoExView,
    },

    // Admin Routes
    {
        path: "/admin/users",
        name: "Admin Users",
        component: UsersViews,
    },
    {
        path: "/admin/mail",
        name: "Admin Mail Send",
        component: MailView,
    },
    {
        path: "/admin/plans",
        name: "Admin Plans",
        component: PlansView,
    },
    {
        path: "/admin/teams",
        name: "Admin Teams",
        component: TeamsView,
    },
    {
        path: "/admin/clean",
        name: "Admin Trash",
        component: TrashView,
    },
    {
        path: "/admin/notify",
        name: "Admin Notify",
        component: NotifyView,
    },
    {
        path: "/admin/new-team",
        name: "New Teams",
        component: NewTeamView,
    },
    {
        path: "/admin/files",
        name: "Files",
        component: FilesView,
    },
    {
        path: "/admin/gifs",
        name: "Gifs",
        component: GifsView,
    },

    // politicas
    { path: "/terms", name: "terms", component: TermsView },
    { path: "/privacy", name: "privacy", component: PolicyView },

    // Auth Routes
    { path: "/login", name: "login", component: LoginComponent },
    { path: "/login", name: "login", component: LoginComponent },
    { path: "/signup", name: "signup", component: LoginComponent },
    { path: "/password/email", name: "forget", component: LoginComponent },
    {
        path: "/password/reset/:email/:key",
        name: "changePass",
        component: LoginComponent,
    },
    { path: "/help", name: "help", component: HelpComponent },

    // 404
    { path: "/:catchAll(.*)", name: "404", component: NotFoundView },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
